import React, { useState, useEffect } from "react"
import { CountdownContainer, CountdownText, CountdownSquare, CountdownInfo } from "./styles"

const Countdown = ({ deadline, type }) => {
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  const getRemainingTime = () => {
    const now = new Date()
    const remainTime = (new Date(deadline) - now + 1000) / 1000
    const remainSeconds = setSeconds(
      ("0" + Math.floor(remainTime % 60)).slice(-2)
    )
    const remainMinutes = setMinutes(
      ("0" + Math.floor((remainTime / 60) % 60)).slice(-2)
    )
    const remainHours = setHours(
      ("0" + Math.floor((remainTime / 3600) % 24)).slice(-2)
    )
    const remainDays = setDays(Math.floor(remainTime / (3600 * 24)))

    return {
      remainSeconds,
      remainMinutes,
      remainHours,
      remainDays,
      remainTime,
    }
  }

  useEffect(() => {
    if (getRemainingTime().remainTime > 1) {
      const interval = setInterval(getRemainingTime, 1000)
      return () => clearInterval(interval)
    }
  }, [])

  return (
    <>
      {type === "discount" && <CountdownInfo>Descuento activo durante:</CountdownInfo>}
      {type === "nextCoupon" && <CountdownInfo>Próximo cupón en:</CountdownInfo>}
      <CountdownContainer>
        <CountdownSquare>
          <span>{days}</span>
          <CountdownText>D</CountdownText>
        </CountdownSquare>
        <CountdownSquare>
          <span>{hours}</span>
          <CountdownText>H</CountdownText>
        </CountdownSquare>
        <CountdownSquare>
          <span>{minutes}</span>
          <CountdownText>M</CountdownText>
        </CountdownSquare>
        <CountdownSquare>
          <span>{seconds}</span>
          <CountdownText>S</CountdownText>
        </CountdownSquare>
      </CountdownContainer>
    </>
  )
}

export default Countdown
